"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgUnlock = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_UNLOCK", width: "1em", height: "1em", viewBox: "0 0 15 12" }, props),
    React.createElement("path", { d: "M3.75 0A3.75 3.75 0 0 0 0 3.75v1.5a.75.75 0 0 0 1.5 0v-1.5a2.25 2.25 0 0 1 4.5 0v.98c-.251.036-.452.07-.601.098a1.104 1.104 0 0 0-.899 1.09v4.664c0 .514.356.988.899 1.09.61.114 2.06.328 4.351.328 2.29 0 3.741-.214 4.351-.328.543-.102.899-.576.899-1.09V5.918c0-.514-.356-.988-.899-1.09-.15-.028-.35-.062-.601-.097L12 4.576A31.767 31.767 0 0 0 9.75 4.5c-.872 0-1.622.031-2.25.076V3.75A3.75 3.75 0 0 0 3.75 0ZM6 10.253V6.247C6.666 6.143 7.916 6 9.75 6s3.084.143 3.75.247v4.006c-.666.104-1.916.247-3.75.247s-3.084-.143-3.75-.247Z" }),
    React.createElement("path", { d: "M3.75 0A3.75 3.75 0 0 0 0 3.75v1.5a.75.75 0 0 0 1.5 0v-1.5a2.25 2.25 0 0 1 4.5 0v.98c-.251.036-.452.07-.601.098a1.104 1.104 0 0 0-.899 1.09v4.664c0 .514.356.988.899 1.09.61.114 2.06.328 4.351.328 2.29 0 3.741-.214 4.351-.328.543-.102.899-.576.899-1.09V5.918c0-.514-.356-.988-.899-1.09-.15-.028-.35-.062-.601-.097L12 4.576A31.767 31.767 0 0 0 9.75 4.5c-.872 0-1.622.031-2.25.076V3.75A3.75 3.75 0 0 0 3.75 0ZM6 10.253V6.247C6.666 6.143 7.916 6 9.75 6s3.084.143 3.75.247v4.006c-.666.104-1.916.247-3.75.247s-3.084-.143-3.75-.247Z" }))); };
exports.default = SvgUnlock;
